import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Launch = function Launch(props) {
  useDeprecatedComponentWarning({
    component: 'Launch'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M299 64h149v149h-43v-76L196 346l-30-30 209-209h-76V64zm106 341V256h43v149c0 23-20 43-43 43H107c-24 0-43-20-43-43V107c0-23 19-43 43-43h149v43H107v298h298z"
  }));
};

Launch.displayName = 'Launch';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Launch.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Launch;